module.exports = __webpack_public_path__ + "img/NI.f485333b.svg";